import React, { useEffect } from 'react'
import { useState } from 'react'
import '../../GeneralServices/NewConnection/NewConnectionForm.scss'
import { Grid, Box, Button, Typography, FormControlLabel, FormControl, RadioGroup, Radio, IconButton } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import { useFormik } from 'formik'
import * as Yup from 'yup';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Error from '../../../components/error/error'
import { dBillAPI, downloadBill, downloadBillAdjBill } from '../../../services/Functions'
import { useSelector } from 'react-redux'
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import { isValidCustomerIdLength } from '../../../utils/customerIdValidation';
import { cfpBaseUrl } from '../../../network/urls'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import Success from '../../../components/success/success'

const AmendDuplicateBill = () => {

    const initialValues = {
        iv_application_id: '',
        iv_consumer_id: '',
    }
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [searchBy, setSearchBy] = useState('referenceNo')
    const [referenceNumber, setReferenceNumber] = useState('')
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const { token, code: userCode, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)
    const userCompany = resolveDiscoCompanyCodeForBranding(
        userCode,
        roleId,
        selectedAdminCompanyCode,
    );
    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        values.iv_consumer_id = ''
        values.iv_application_id = ''
        setError()
        setReferenceNumber('')
    };
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_application_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(18, 'Application Id must be 18 digits.').max(18, 'Application Id must be 18 digits.').required("Enter Application Id."),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                applicationId: values.iv_application_id
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "installments/amendDuplicateBill", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        setError('');
                        setSuccess(result.message);

                        // ✅ Direct bill download here
                        const billUrl = `https://bill.pitc.com.pk/pitc/route_access/${Number(result.refNo)}`;
                        window.open(billUrl, "_blank");

                        setViewBackdrop(false);
                    } else {
                        setViewBackdrop(false);
                        setSuccess('');
                        setError(result.message);
                    }
                })
                .catch((error) => {
                    setViewBackdrop(false);
                    setError('Something went wrong while processing the request.');
                });

        }
    })

    const referenceApi = async () => {
        if (searchBy === 'consumerId') {
            setViewBackdrop(true)
            if (!values.iv_consumer_id) return;
            let apiResponse = await dBillAPI(token, values.iv_consumer_id)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
            } else if (apiResponse.status == false) {
                setError('No Data Found against this Customer ID.')
            } else {
                setError('Customer ID. not found!')
            }
            setViewBackdrop(false)
        }
    }

    useEffect(() => {
        if (isValidCustomerIdLength(values.iv_consumer_id, userCompany)) {
            referenceApi();
        } else {
            setReferenceNumber('')
            setError('')
        }
    }, [values.iv_consumer_id])

    const errorCloses = () => {
        setError('')
        setSuccess('')
        // setFieldSurveyError('')
    }

    const handleFormKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit();
        }
    }


    return (
        <>
            <Grid container className='nC'>
                <Box className='nCContainer'>
                    <div className="headingBarDiv">
                        <h3 className="heading">
                            View Duplicate Bill
                        </h3>
                    </div>
                    <form className='ncform' onKeyDown={handleFormKeyDown}>
                        <Typography variant="h6" className="groupTitle">
                            <div className="redCell">
                            </div>
                            Connection Details
                        </Typography>
                        <Grid container className='container' >
                            <Grid item xs={2}>
                                <Typography className='fieldLabel' > Application Id</Typography>
                                <TextField
                                    inputProps={{ maxLength: 18 }}
                                    required
                                    type='text'
                                    autoComplete='off'
                                    name="iv_application_id"
                                    value={values.iv_application_id}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_application_id"
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {errors.iv_application_id && touched.iv_application_id ? (errors.iv_application_id) : null}
                                </Box>
                            </Grid>

                        </Grid>
                        <Grid container>
                            <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                                {error && (
                                    <Error
                                        error={error}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#FFC0CB"
                                        textColor="#bb0303"
                                        iconColor="#bb0303"
                                    />
                                )}

                                {success && (
                                    // <Grid container>
                                    //     <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px',marginTop : 2 }}>
                                    //         <Box
                                    //             sx={{
                                    //                 display: 'flex',
                                    //                 alignItems: 'center',
                                    //                 justifyContent: 'space-between',
                                    //                 backgroundColor: '#C6F6C6',
                                    //                 color: '#066306',
                                    //                 padding: '10px 16px',
                                    //                 borderRadius: '8px',
                                    //                 boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
                                    //             }}
                                    //         >
                                    //             <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    //                 <CheckCircleOutlineIcon sx={{ color: '#066306', mr: 1 }} />
                                    //                 <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                    //                     {success}
                                    //                 </Typography>
                                    //             </Box>

                                    //             <IconButton
                                    //                 onClick={() => errorCloses()}
                                    //                 sx={{ color: '#066306' }}
                                    //                 size="small"
                                    //             >
                                    //                 <CloseIcon />
                                    //             </IconButton>
                                    //         </Box>
                                    //     </Grid>
                                    // </Grid>
                                    <Success
                                        error={success}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#C6F6C6"
                                        textColor="#066306"
                                        iconColor="#066306"
                                    />
                                )}
                            </Grid>
                        </Grid>


                        <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
                            <Button className={(values.iv_application_id.length === 18 || referenceNumber.length === 18) === false ? 'disabled-button' : 'button'}
                                variant="contained" component="label" onClick={handleSubmit} disabled={(values.iv_application_id.length === 18 || referenceNumber.length === 18) === false}>
                                Submit
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Grid>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}

export default AmendDuplicateBill
